import { getJobsProfile } from "./job-services";

export { getJobsProfile };
